export const BaseSlider = () => {
  return <div></div>;
};
